import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import ImageWithReservedSpace from 'components/Common/ImageWithReservedSpace'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import TextButton from 'LuxKit/Button/TextButton'
import VerticalSpacer from '../Spacing/VerticalSpacer'

export const InnerWrapper = styled(PaneBody)`
  display: grid;
  grid-gap: ${rem(18)};

  ${mediaQueryUp.tablet} {
    grid-gap: ${rem(24)};
    grid-template-rows: 1fr min-content;
    grid-template-columns: 1fr ${rem(306)};
  }

  @media print {
    display: grid;
    grid-gap: ${rem(18)};
  }
`

export const OfferInnerWrapper = styled(InnerWrapper)`
  ${mediaQueryDown.mobile} {
    padding-bottom: 0;
  }
`

export const ItemPane = styled(Pane)`
  position: relative;
  min-height: ${rem(120)};

  @media print {
    border: 1px solid ${props => props.theme.palette.neutral.default.five} !important;
  }
`

export const BaseImage = styled(ImageWithReservedSpace)`
  grid-column: 1 / 2 span;

  ${mediaQueryUp.tablet} {
    grid-column: 2;
  }

  @media print {
    grid-column: 2;
  }
`

export const InfoBox = styled(VerticalSpacer)`
  ${mediaQueryUp.tablet} {
    grid-row: 1;
  }

  @media print {
    grid-row: 1;
  }
`

export const ItemDetails = styled(Pane)`
  grid-column: 1 / 2 span;
  margin-left: ${rem(-16)};
  margin-right: ${rem(-16)};

  ${mediaQueryUp.tablet} {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
`

export const ItemDetail = styled(PaneBody)`
  display: grid;
  grid-template-columns: ${rem(24)} 1fr;
  grid-gap: ${rem(24)};
  align-items: center;

  ${mediaQueryUp.tablet} {
    grid-template-columns: ${rem(24)} 1fr ${rem(152)};
  }

  & + & {
    border-top: 1px solid ${props => props.theme.palette.neutral.default.five};
  }
`

export const StyledCalendarIcon = styled(LineCalendarIcon)`
  align-self: center;
`

export const StyledInfoIcon = styled(LineInfoCircleIcon)`
  align-self: flex-start;
`

export const DetailCta = styled(TextButton)`
  align-self: flex-start;
  grid-column: 1 / 2 span;

  ${mediaQueryUp.tablet} {
    grid-column: auto;
  }

  @media print {
    display: none;
  }
`

export const BookingInfo = styled.div`
  grid-column: 1 / 2 span;

  ${mediaQueryUp.tablet} {
    grid-row: 2;
    grid-column: auto;
  }
`
